import cashActivityComponent from "./cash_activity.component";

let cashActivityModule = angular
  .module("cashActivity", [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise("/cashActivity");

    $stateProvider.state("cashActivity", {
      url: "/v2/index.html#/cash-activity",
      component: "cashActivity",
      data: {
        requireLogin: true,
        requireACL: "cash_activity.customer,funding_source",
      },
    });
  })
  .component("cashActivity", cashActivityComponent).name;

export default cashActivityModule;



// WEBPACK FOOTER //
// ./client/app/components/cash_activity/index.js